import { render, staticRenderFns } from "./InelegibleForm.vue?vue&type=template&id=06ea3e9e&scoped=true"
import script from "./InelegibleForm.vue?vue&type=script&lang=js"
export * from "./InelegibleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ea3e9e",
  null
  
)

export default component.exports